import { render, staticRenderFns } from "./VatNumber.vue?vue&type=template&id=27e6ae0c&"
import script from "./VatNumber.vue?vue&type=script&lang=ts&"
export * from "./VatNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports